var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-excel" },
    [
      _c("input", {
        staticClass: "input-file",
        attrs: {
          id: "referenceUpload",
          type: "file",
          accept:
            ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
        },
        on: { change: _vm.exportData },
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          attrs: { size: "small" },
          on: { click: _vm.btnClick },
        },
        [
          _vm._v(
            _vm._s(
              _vm.distinguish == 2 ? "导入" : _vm.$t("finance.batchupload")
            )
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }